module.exports = "/assets/data/d4d2344fc4c6cbcf7da79c4b393e536e-NE8.data.json";